import { NgModule , LOCALE_ID} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { ErrorHandlerInterceptor } from './shared/interceptors/error.interceptor';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import { DecimalPipe, registerLocaleData } from '@angular/common';
import localesEs from '@angular/common/locales/es';
import { NgIdleModule } from '@ng-idle/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

registerLocaleData(localesEs, 'es_CL');

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgIdleModule.forRoot(),
    ModalModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    }, 
    {
      provide: LOCALE_ID,
      useValue: 'es_CL',
    }, 
    DecimalPipe,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 
  constructor( private bsLocaleService: BsLocaleService){
    this.bsLocaleService.use('es_CL');//fecha en español, datepicker
  }
}
